import { render, staticRenderFns } from "./IconRepository.vue?vue&type=template&id=1c3a862e&scoped=true&"
import script from "./IconRepository.vue?vue&type=script&lang=js&"
export * from "./IconRepository.vue?vue&type=script&lang=js&"
import style0 from "./IconRepository.vue?vue&type=style&index=0&id=1c3a862e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3a862e",
  null
  
)

export default component.exports